import { render, staticRenderFns } from "./SubCategoriesList.vue?vue&type=template&id=56f5935a&scoped=true&"
import script from "./SubCategoriesList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SubCategoriesList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SubCategoriesList.vue?vue&type=style&index=0&id=56f5935a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5935a",
  null
  
)

export default component.exports